<template>
  <div style="height: 100%;">
    <SplitContainer21 style="height: 100%" :layout="12">
      <template #top>
        <TableMain name="one table" ref="VendTable1" :fields="fields" :title="table_title.title1"
          :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
          :show_date_picker="true" :show_toolbar="false" :show_filter="true" :date_picker_label="date_picker_label"
          :query_button_label="query_lable" :isBusy="isBusy_table1" :hb_table_class="'hb_table_vendsei_class1'"
          :loading_width="100" :table_height_adjust="-8" @on_query="on_query" :show_toolbar_button="[0, 0, 0, 0, 0]"
          @current_changed="current_changed">
          <template #query>
            {{ $t("common.provider") + $t("common.account") }}：<el-input clearable size="small" style="width: 150px"
              v-model="AccountNum"></el-input>
            {{ $t("common.provider") + $t("common.name") }}：<el-input clearable size="small" style="width: 200px"
              v-model="supplier_name"></el-input>
          </template>
          <template #toolbar>
            <el-tooltip content="数据同步" placement="top" effect="light">
              <el-button type="info" plain style="width: 55px" class="ml-2" @click="InvokeData"><i
                  class="iconfont icon-refresh"></i></el-button>
            </el-tooltip>
          </template>
          <template #operation>
            <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'" @on_query="SaveData"
              :label="$t('common.save')" class="ml-2">
            </QueryButton>
          </template>
        </TableMain>
      </template>
      <template #bottom>
        <TableMain name="one table" ref="VendTable2" :fields="fields2" :title="table_title.title2"
          :show_query_container="false" :show_toolbar_container="true" :show_pagination_container="true"
          :show_date_picker="false" :show_toolbar="false" :show_filter="true" :date_picker_label="date_picker_label"
          :query_button_label="query_lable" :loading_width="40" :isBusy="isBusy_table2"
          :hb_table_class="'hb_table_vendsei_class2'" tableref="3356e30bd1904ea6aa271df1c83192dc">
        </TableMain>
      </template>
    </SplitContainer21>
  </div>
</template>

<script>
// -- import * as _ from "lodash-es"
import * as VendTableController from "../../controllers/base/VendTableController"
import QueryButton from "../components/base/QueryButton"
import TestQueryPanel from "../components/base/TestQueryPanel"
import BaseContainer from "../components/BaseContainer"
import SplitContainer21 from "../components/container/SplitContainer21"
import BaseModal from "../components/modals/baseModal"
import TableMain from "../components/table/TableMain"

export default {
  name: "VendTableSEI",
  components: {
    QueryButton,
    BaseContainer,
    TableMain,
    BaseModal,
    TestQueryPanel,
    SplitContainer21,
  },
  data() {
    return {
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_sei_vend",
        title2: "table_vend",
      },
      fields: VendTableController.fields.default,
      fields2: VendTableController.fields.detail_fields,
      isBusy_table1: false,
      isBusy_table2: false,
      AccountNum: "",
      supplier_name: "",
      _date_range: null,
      _set_data: null,
      dispatcherList: [],
      // his_vend_dt:[]
    }
  },
  async created() {
    // let _dt = await RoleManageController.methods.GetRoleList();
    // _dt = _.filter(_dt, { is_sys: false, is_valid: true });
    // this.dispatcherList = _.map(_dt, (t) => {
    //   return {
    //     value: t.code,
    //     label: t.name,
    //   };
    // });
    ///邮件通知人
    let _field1 = _.find(this.fields, { key: "EmailNotifier" })
    _field1["multiple"] = true
    _field1["_options"] = {
      provider: (v) => {
        let users = _.map(this.$store.state.biz_data.baseData.Users, (t) => {
          return {
            value: t.username,
            label: t.username,
          }
        })
        // let dt = _.union(this.dispatcherList, users)
        return users
      },
    }
  },
  methods: {
    //#region 查询
    async on_query(set_data, date_range) {
      ///模拟数据
      this.isBusy_table1 = true
      if (!set_data || _.isNull(set_data)) {
        this.isBusy_table1 = false
        return
      } else {
        this._date_range = date_range
        this._set_data = set_data
      }
      this.AccountNum = _.trim(this.AccountNum)
      this.supplier_name = _.trim(this.supplier_name)
      await this.excuteQuery(set_data, date_range)
      this.isBusy_table1 = false
    },
    async excuteQuery(set_data, date_range) {
      let _fromDate = "",
        _toDate = ""
      let _params = {
        SEI_Name: { like: "%" + this.supplier_name + "%" },
      }
      _params.is_deleted_ax = { "=": 0 }
      if (this.AccountNum != "") {
        _params.AccountNum = { like: "%" + this.AccountNum + "%" }
      }
      if (
        !_.isNull(date_range) &&
        this.AccountNum == "" &&
        this.supplier_name == ""
      ) {
        _fromDate = this.$date.format(date_range[0], "yyyy-MM-dd")
        _toDate = this.$date.format(date_range[1], "yyyy-MM-dd")
        _toDate = this.$date.format(
          this.$date.addDays(new Date(_toDate), 1),
          "yyyy-MM-dd"
        )
        _params["modifiedDateTime"] = { ">=": _fromDate, "<=": _toDate }
      }
      set_data([])
      let _result = await VendTableController.methods.getData(_params)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        _.each(_result[0], (t) => {
          if (t.EmailNotifier && t.EmailNotifier.indexOf(",") > -1) {
            t.EmailNotifier = _.split(t.EmailNotifier, ",")
          }
          else if (_.isString(t.EmailNotifier)) {
            let ut = []
            ut.push(t.EmailNotifier)
            t.EmailNotifier = ut
          }
        })
        let _dt = _.orderBy(_result[0], ["modifiedDateTime"], ["desc"])
        this.his_vend_dt = _.cloneDeep(_dt)
        set_data(_dt)
      }
      this.isBusy_table1 = false
    },
    //#endregion

    current_changed(old, current) {
      if (_.isNull(current)) {
        this.$refs.VendTable2.SetData([])
        return
      }
      this.getItemData(current)
    },
    async getItemData(current) {
      this.isBusy_table2 = true
      this.$refs.VendTable2.SetData([])
      let _result = await VendTableController.methods.getItemData({
        AccountNum: { "=": current.AccountNum },
        is_deleted_ax: { "=": 0 },
      })

      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.$refs.VendTable2.SetData(_.orderBy(_result[0], ["id"], ["asc"]))
      }
      this.isBusy_table2 = false
    },
    async InvokeData() {
      // this.isBusy_table1 = true;
      // this.$refs.CustTable1.SetData([]);
      const loading = this.$loading({
        lock: true,
        text: this.$t("notify.in_async"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })

      let _is_wait = true
      setTimeout(() => {
        if (_is_wait) {
          this.msgToasts(this.$t("notify.async_timeout"), "info")
          loading.close()
          _is_wait = false
        }
        return
      }, 1000 * 60 * 5)

      let companys = this.$store.state.biz_data.baseData.CompanyInfo
      for (var i in companys) {
        let _params = {
          company: companys[i].DataArea,
          tableName: "secp_VendTable",
          accountNum: "", //不传则查询所有
        }
        await VendTableController.methods.pickAndInvoke(_params)
      }
      let _p = {
        company: "070",
        tableName: "secp_SEI_VendTable",
        accountNum: "", //不传则查询所有
      }
      await VendTableController.methods.pickAndInvoke(_p)
      loading.close()
      if (_is_wait) {
        this.msgToasts(this.$t("notify.async_success"), "success")
        _is_wait = false
      }
      this.isBusy_table1 = true
      if (isNaN(this._set_data) && isNaN(this._date_range)) {
        this.$refs.VendTable1.SetData([])
        let _params = {
          modifiedDateTime: {
            ">=": this.$date.format(
              new Date().setMonth(new Date().getMonth() - 1),
              "yyyy-MM-dd"
            ),
            "<=": this.$date.format(
              this.$date.addDays(new Date(), 1),
              "yyyy-MM-dd"
            ),
          },
        }
        let _result = await VendTableController.methods.getData(_params)
        if (!_.isNull(_result) && _result && _result.length > 0) {
          this.$refs.VendTable1.SetData(
            _.orderBy(_result[0], ["modifiedDateTime"], ["desc"])
          )
        }
      } else {
        await this.on_query(this._set_data, this._date_range)
      }

      this.isBusy_table1 = false
    },
    //保存供应商邮件通知人
    async SaveData(cb) {
      let diff_data = []
      diff_data = this.$refs.VendTable1.GetSelectedItems()
      if (diff_data.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        cb(false)
        return
      }
      //检查邮箱格式
      let msg = ""
      _.each(diff_data, (t) => {
        if (t.EmailContact && t.EmailContact != "") {
          // let elt = []
          let eurl = t.EmailContact.replace(/；/g, ";")
          let emails = eurl.split(";")
          for (var i in emails) {
            if (msg == "" && !_.trim(emails[i]).match(/^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/))
              msg = "邮箱格式不正确，请检查后再保存！"
            // else
            //   elt.push(_.trim(emails[i]))
          }
          // if (msg == "" && elt.length > 0)
          //   t.EmailContact = _.join(elt, ";")
        }
      })
      if (msg != "") {
        this.msgToasts(msg, "info")
        cb(false)
        return
      }

      let save_items = []
      _.each(diff_data, (mt) => {
        let t = _.cloneDeep(mt)
        if (t.EmailNotifier && _.isArray(t.EmailNotifier) && t.EmailNotifier.length > 0) {
          t.EmailNotifier = _.join(t.EmailNotifier, ",")
        }
        else if (!_.isString(t.EmailNotifier)) {
          t.EmailNotifier = null
        }
        save_items.push({
          id: t.id,
          Dispatcher: t.Dispatcher,
          EmailNotifier: t.EmailNotifier,
          EmailContact: t.EmailContact
        })
      })

      let _result = await VendTableController.methods.saveData(
        save_items
      )
      if (_result) {
        _.each(diff_data, (t) => {
          let _m = _.find(this.his_vend_dt, { id: t.id })
          if (_m) {
            _m.Dispatcher = t.Dispatcher
          }
        })
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        cb(true)
      } else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        cb(false)
      }
    },
  },
}
</script>
<style>
.hb_table_vendsei_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 108rem;
}

.hb_table_vendsei_class2 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 250rem;
}
</style>
